/**
 * created by li si yi
 * 上传文件统计
 */
import React, {Component} from 'react';
import {Input, Select, Button, DatePicker, Pagination, Modal, Radio, Tabs} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";
import BaseComponent from "../../../../../base/BaseComponent";
import BaseTable from "../../../../components/baseTable/BaseTable";
import sort from "./image/sort.png"
import sortCheck from "./image/sortColor.png"

const {RangePicker} = DatePicker;
const {Search} = Input;
const {TabPane} = Tabs;

export default class UploadStatistics extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            params: {
                page: 1,  //页数
                size: 10,  //每页数量
                queryStr: "",  //模糊查询
                startTime: moment().month(moment().month()).startOf('month'),
                endTime: moment().month(moment().month()).endOf('month'),  //结束时间
                rank: "1",// 类型
            },
            total: 0,//总数
            dataSource: [],//列表数据
            btnText: "本月",
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDataSource();
    }

    render() {
        return (
            <div style={{margin: "15px"}}>
                <div style={{
                    backgroundColor: "#fff",
                    width: "100%",
                    maxHeight: 'calc(100vh - 100px)',
                    borderRadius: '5px',
                    // overflow: 'hidden',
                }}>
                    <div style={{padding: '24px 32px'}}>
                        {this.renderHeader()}
                    </div>
                    {this.renderContent()}
                </div>
            </div>
        )
    }

    // 头部
    renderHeader() {
        const publicStyle = {marginRight: 20};
        return (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div style={{display: 'flex'}}>
                    <div style={publicStyle}>
                        <Search
                            placeholder="请输入作者名称"
                            value={this.state.params.queryStr}
                            onChange={(e) => {
                                this.state.params.queryStr = e.target.value;
                                this.setState({})
                            }}
                            onSearch={value => this.userIdOnSearch(value)}
                            style={{width: 200}}
                        />
                    </div>
                    <Button style={publicStyle} type="primary" onClick={() => this.revert()}>重置</Button>
                </div>
                <div style={{height: 32}} className={'selectedPicker'}>
                    <Radio.Group value={this.state.btnText} onChange={this.handleSizeChange}
                                 style={{marginRight: '10px'}}>
                        <Radio.Button value="本月">本月</Radio.Button>
                        <Radio.Button value="上月">上月</Radio.Button>
                        <Radio.Button value="本年">本年</Radio.Button>
                        <Radio.Button value="去年">去年</Radio.Button>
                    </Radio.Group>
                    <RangePicker
                        getPopupContainer={triggerNode => triggerNode.parentNode} allowClear
                        value={[this.state.params.startTime, this.state.params.endTime]}
                        style={{width: 230}}
                        onChange={this.rangePickerChange}/>
                </div>
                <style>
                    {
                        `
                                 .selectedPicker .ant-calendar-picker-input.ant-input{
                                    background:#f6f8fd;
                                 }
                                 .selectedPicker .ant-calendar-input-wrap .ant-calendar-date-input-wrap .ant-calendar-input {
                                    
                                    width:150px !important;
                                    background:red;
                                 }
                         `
                    }
                </style>
            </div>
        )
    }

    //内容
    renderContent() {
        let columns = [
            {
                title: '作者',
                dataIndex: 'author',
                ellipsis: true,
                key: 'author',
                width: '150px',
                render: (text) => {
                    return (
                        <div>
                            {text ? text : 0}
                        </div>
                    )
                }
            },
            {
                title: <div>图片数
                    <img
                        src={this.state.params && this.state.params.rank && this.state.params.rank === "1" ? sortCheck : sort}
                        style={{width: '12px', height: '12px'}}
                        onClick={() => {
                            this.state.params.rank = "1";
                            this.setState({}, () => {
                                this.getDataSource()
                            });
                        }}/>
                </div>,
                dataIndex: 'photo',
                key: 'photo',
                width: '150px',
                render: (text) => {
                    return (
                        <span>{text ? text : 0}</span>
                    )
                }
            },
            {
                title: <div>视频数
                    <img
                        src={this.state.params && this.state.params.rank && this.state.params.rank === "2" ? sortCheck : sort}
                        style={{width: '12px', height: '12px'}}
                        onClick={() => {
                            this.state.params.rank = "2";
                            this.setState({}, () => {
                                this.getDataSource()
                            });
                        }}/>
                </div>,
                dataIndex: 'video',
                ellipsis: true,
                key: 'video',
                width: '150px',
                render: (text) => {
                    return (
                        <span>{text ? text : 0}</span>
                    )
                }
            },
            {
                title: <div>音频数
                    <img
                        src={this.state.params && this.state.params.rank && this.state.params.rank === "3" ? sortCheck : sort}
                        style={{width: '12px', height: '12px'}}
                        onClick={() => {
                            this.state.params.rank = "3";
                            this.setState({}, () => {
                                this.getDataSource()
                            });
                        }}/>
                </div>,
                dataIndex: 'audio',
                ellipsis: true,
                key: 'audio',
                width: '150px',
                render: (text) => {
                    return (
                        <span>{text ? text : 0}</span>
                    )
                }
            },
            {
                title: <div>其他
                    <img
                        src={this.state.params && this.state.params.rank && this.state.params.rank === "4" ? sortCheck : sort}
                        style={{width: '12px', height: '12px'}}
                        onClick={() => {
                            this.state.params.rank = "4";
                            this.setState({}, () => {
                                this.getDataSource()
                            });
                        }}/>
                </div>,
                dataIndex: 'other',
                ellipsis: true,
                key: 'other',
                width: '150px',
                render: (text) => {
                    return (
                        <span>{text ? text : 0}</span>
                    )
                }
            },
        ];
        return (
            <div className={"nullStyle"}>
                <div style={{maxHeight: 'calc(100vh - 261px)', padding: '0px 32px'}}>
                    <Scrollbars autoHeightMax={"calc(100vh - 261px)"} autoHeight>
                        <BaseTable
                            rowKey="id"
                            dataSource={this.state.dataSource}
                            columns={columns}
                            pagination={false}
                            locale={{emptyText: '暂无数据'}}
                            onChange={this.onChange}
                        />
                    </Scrollbars>
                    <style>{`
                    .nullStyle .ant-table-placeholder{
                       display:flex;
                       justify-content: center;
                       align-items: center;
                    //    height:500px;
                       border-bottom:none;
                    }
                `}</style>
                </div>
                {this.renderFooter()}
            </div>
        )
    }

    onChange(pagination, filters, sorter, extra) {
        console.log('params', pagination, filters, sorter, extra);
    }

    // 分页
    renderFooter = () => {
        let {params, total} = this.state;
        // 获取当前tab参数
        let {page, size} = params;
        return (
            <div className={'pagination'} >
                <div style={{padding: "0 10px 0"}}>共{total}条数据</div>
                <Pagination
                    showSizeChanger
                    current={page}
                    pageSize={size}
                    total={total}
                    showQuickJumper={true}
                    onChange={(page, pageSize) => this.pageChange(page, pageSize)}
                    onShowSizeChange={(page, pageSize) => this.pageChange(page, pageSize)}
                />
            </div>
        )
    };

    //获取列表数据
    getDataSource = () => {
        let {params} = this.state;
        let body = JSON.parse(JSON.stringify(params));
        if (body.startTime && body.endTime) {
            body.startTime = moment(body.startTime).format('YYYY-MM-DD');
            body.endTime = moment(body.endTime).format('YYYY-MM-DD');
        }
        this.request({
            url: '/cm-sites-storage-management/zykStatistics/UploadStatistics',
            method: 'get',
            body: body,
            callBack: (res) => {
                let dataSource = [];
                let total = 0;
                if (res) {
                    dataSource = res.data;
                    total = res.count;
                }
                this.setState({dataSource, total})
            }
        })
    };
    handleSizeChange = e => {
        let {currentActiveKey} = this.state;
        let data = e.target.value;
        let startTime;
        let endTime;
        if (data === "上月") {
            startTime = moment().month(moment().month() - 1).startOf('month');
            endTime = moment().month(moment().month() - 1).endOf('month');
            console.log(moment().day(moment().day() - 1).startOf('day'));
        } else if (data === "去年") {
            startTime = moment().year(moment().year() - 1).startOf('year');
            endTime = moment().year(moment().year() - 1).endOf('year');
            console.log(startTime, endTime);
        } else if (data === "本月") {
            startTime = moment().month(moment().month()).startOf('month');
            endTime = moment().month(moment().month()).endOf('month');
        } else if (data === "本年") {
            startTime = moment().year(moment().year()).startOf('year');
            endTime = moment().year(moment().year()).endOf('year');
            console.log(startTime, endTime);
        }
        this.state.btnText = e.target.value;
        this.state.params.startTime = startTime;
        this.state.params.endTime = endTime;
        this.setState({}, () => {
            this.getDataSource()
        });
    };

    rangePickerChange = (data, dateString) => {
        let startTime = data && data[0] ? data[0].startOf('day') : null;
        let endTime = data && data[1] ? data[1].endOf('day') : null;
        this.state.params.startTime = startTime;
        this.state.params.endTime = endTime;
        this.state.btnText = "";
        this.setState({});
        this.getDataSource();
    };

    //分页
    pageChange(page, pageSize) {
        let {params} = this.state;
        params.page = page;
        params.size = pageSize;
        this.getDataSource();
    }

    //作者名称搜索
    userIdOnSearch(value) {
        let {params} = this.state;
        params.queryStr = value.replace(/[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]+/g, "");
        params.page = 1;
        this.getDataSource();
    }

    //重置按钮
    revert() {
        this.state.params = {
            page: 1,
            size: 10,
            queryStr: "",
            startTime: moment().month(moment().month()).startOf('month'),
            endTime: moment().month(moment().month()).endOf('month'),
            rank: "1",
        };
        this.setState({});
        this.getDataSource()
    }
}